import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import Modal from '@/components/UI/Modal';
export default {
  name: 'BumpModal',
  props: {
    buttons: {
      type: Object,
      required: true
    },
    showYellowBg: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '开大奖'
    },
    bg: {
      type: String,
      default: ''
    }
  },
  components: {
    Modal: Modal
  },
  settingKey: '弹框UI',
  setting: {
    大背景: 'https://puui.qpic.cn/vupload/0/20190624_1561358161977_127oemrwgcfj.png/0',
    小背景: 'https://puui.qpic.cn/vupload/0/20190624_1561360729584_ochp9ylgoh.png/0',
    标题背景: {
      type: 'object',
      properties: {
        空白: 'https://puui.qpic.cn/vupload/0/20190624_1561377951369_82keebrnzzw.png/0',
        开大奖: 'https://puui.qpic.cn/vupload/0/20190624_1561360968065_90cwc13fisn.png/0'
      }
    }
  },
  computed: {
    titleStyle: function titleStyle() {
      if (Object.keys(this.setting.标题背景).includes(this.title) && this.title !== '空白') {
        return {
          backgroundImage: "url(".concat(this.setting.标题背景[this.title], ")"),
          color: 'rgba(0,0,0,0)'
        };
      } else {
        return {
          backgroundImage: "url(".concat(this.setting.标题背景.空白, ")"),
          color: 'white'
        };
      }
    }
  }
};